/**
 * NonCounterEffects — what putting an officer on a non-counter deployment does, as the same short bullets
 * wherever it is explained (Settings, the cell popover). The wording lives in utils/counterChoice.
 */
import { NON_COUNTER_EFFECTS } from '@/utils/counterChoice';

export function NonCounterEffects({ fontSize = 13, color = '#475569' }: { fontSize?: number; color?: string }) {
  return (
    <ul style={{ margin: '4px 0 0', paddingLeft: 18, fontSize, color, lineHeight: 1.45 }}>
      {NON_COUNTER_EFFECTS.map((line) => <li key={line}>{line}</li>)}
    </ul>
  );
}
